
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","baseProfile":"tiny","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 21","overflow":"visible"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 18.833c-4.595 0-8.334-3.738-8.334-8.334S5.405 2.166 10 2.166s8.334 3.738 8.334 8.334-3.74 8.333-8.334 8.333zm0-15.334c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7z"}}),_c('path',{attrs:{"d":"M9.793 12.212a.666.666 0 01-.646-.831c.268-1.06.965-1.55 1.475-1.91.55-.386.773-.566.773-1.143 0-1.23-1.213-1.243-1.265-1.243-.415 0-1.394.106-1.531 1.091a.666.666 0 11-1.32-.183c.23-1.655 1.68-2.242 2.85-2.242 1.26 0 2.6.903 2.6 2.577 0 1.292-.775 1.837-1.34 2.234-.449.316-.803.565-.951 1.147a.667.667 0 01-.646.503z"}}),_c('circle',{attrs:{"cx":"9.815","cy":"13.954","r":".917"}})])
          )
        }
      }
    